import { useState } from 'react';
import { getConnector } from '../services/PatientFacingClient';

interface AttachmentCache {
  [key: string]: string;
}

const attachmentBlobCache: AttachmentCache = {};
const attachmentTokenCache: AttachmentCache = {};
const fetchingBlob: AttachmentCache = {};
const fetchingUrl: AttachmentCache = {};

export const useAttachment = (messageId: string, attachmentId: string, viewableMedia: boolean) => {
  const { client } = getConnector();

  const [attachmentBlobUrl, setAttachmentBlobUrl] = useState('');
  const [attachmentTokenUrl, setAttachmentTokenUrl] = useState('');

  let attachmentKey = `${messageId}.${attachmentId}`;

  const fetchAttachmentToken = async () => {
    const attachmentUrl = attachmentTokenCache[attachmentKey];

    if (!attachmentUrl && !fetchingUrl[attachmentKey]) {
      fetchingUrl[attachmentKey] = 'loading';
      const url = await client.messages.getAttachmentUrlWithToken(messageId, attachmentId, true);

      attachmentTokenCache[attachmentKey] = url;
      setAttachmentTokenUrl(url);

      delete fetchingUrl[attachmentKey];
    } else {
      setAttachmentTokenUrl(attachmentUrl);
    }
  };

  const fetchAttachmentBlob = async () => {
    if (!viewableMedia) return;

    const attachmentData = attachmentBlobCache[attachmentKey];

    if (!attachmentData && !fetchingBlob[attachmentKey]) {
      fetchingBlob[attachmentKey] = 'loading';
      const url = await client.messages.downloadAttachmentUrlWithToken(messageId, attachmentId);

      attachmentBlobCache[attachmentKey] = url;
      setAttachmentBlobUrl(url);

      delete fetchingBlob[attachmentKey];
    } else {
      setAttachmentBlobUrl(attachmentData);
    }
  };

  const initiateFetching = (newMessageId?: string, newAttachmentId?: string) => {
    if (newMessageId) messageId = newMessageId;
    if (newAttachmentId) attachmentId = newAttachmentId;
    attachmentKey = `${messageId}.${attachmentId}`;

    fetchAttachmentToken();
    fetchAttachmentBlob();
  };

  const invalidateAttachmentToken = () => {
    delete attachmentTokenCache[attachmentKey];
    setAttachmentTokenUrl('');
    fetchAttachmentToken();
  };

  return {
    attachmentBlobUrl,
    attachmentTokenUrl,
    initiateFetching,
    invalidateAttachmentToken,
  };
};

export default useAttachment;
